import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import './HomePage.css';
import RoleLayout from './component/RoleLayout';
import DownArrowAnim from "./component/anime/DownArrowAnim";

function Home() {
    document.title = '命理规划旺运设计师'


    return (
        <RoleLayout>
            <div className='screen1'>
                <img className="demo-bg" src="/public-static/taiji.jpg" alt=""></img>
                <Container>
                    <Row>
                        <Col className='colContent'>
                            <Row>
                                <Col className="d-flex justify-content-center align-items-center">
                                    <h1 className="head1"><strong>八字 奇门 风水 落阴</strong></h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={5}></Col>
                                <Col className="d-flex justify-content-center align-items-center">
                                    <p className="head1-1"><strong></strong></p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="screen1-content">
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">命卦吉凶与生命短板</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">阳宅风水规划设计</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">企业办公楼风水设计</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">企业发展规划设计</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">阴宅补地脉聚龙气</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">八字关口大限因果线化解</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">阴阳宅原址天官风水</p>
                        </Col>
                    </Row>
                </Container>
                <div className="downArrow">
                    <DownArrowAnim />
                </div>
            </div>
            <div className='screen3'>
                <img className="demo-bg2" src="/public-static/screen2.png" alt=""></img>
                <Container>
                    <Row className="colContent-yunchou">
                        <Col>
                            <Row>
                                <Col className="d-flex justify-content-center align-items-center">
                                    <h1 className="head1-yunchou"><strong>奇門綜閤運籌</strong></h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={5}></Col>
                                <Col className="d-flex justify-content-center align-items-center">
                                    <p className="head1-1"><strong>转运旺运不求人</strong></p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="colContent-wangyun">
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">催财旺运</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">催文昌事业</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">催桃花人缘</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center">
                            <p className="head1-content">心想事成阵法</p>
                        </Col>
                    </Row>
                </Container>
            </div >
            <div className='screen4'>
                <Container>
                    <Row xs={1} md={2} className='colContent-half d-flex justify-content-center align-items-center'>
                        <Col xs={10} md={6}>
                            <Row>
                                <Col className="d-flex justify-content-center align-items-center">
                                    <h3>奇门手机旺运号码设计</h3>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={10} md={6}>
                            <Row>
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span className="numberBox">1</span>
                                    <span className="numberBox">3</span>
                                    <span className="numberBox">7</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">3</span>
                                    <span className="numberBox">7</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">?</span>
                                </Col>
                            </Row>
                            <Row className="rowNumber">
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span className="numberBox">1</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">1</span>
                                    <span className="numberBox">0</span>
                                    <span className="numberBox">7</span>
                                    <span className="numberBox">6</span>
                                    <span className="numberBox">9</span>
                                    <span className="numberBox">5</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">?</span>
                                </Col>
                            </Row>
                            <Row className="rowNumber">
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span className="numberBox">1</span>
                                    <span className="numberBox">3</span>
                                    <span className="numberBox">4</span>
                                    <span className="numberBox">5</span>
                                    <span className="numberBox">0</span>
                                    <span className="numberBox">3</span>
                                    <span className="numberBox">7</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">?</span>
                                    <span className="numberBox">?</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row xs={1} md={2} className='colContent-half d-flex justify-content-center align-items-center'>
                        <Col xs={10} md={6}>
                            <Row>
                                <Col className="d-flex justify-content-center align-items-center">
                                    <h3>微信头像旺运设计</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="d-flex justify-content-center align-items-center">
                                    <p> 观物定像 </p>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={10} md={6}>
                            <Row>
                                <Col><img className="headImg" src="/public-static/head1.jpg" alt=""></img></Col>
                                <Col><img className="headImg" src="/public-static/head2.jpg" alt=""></img></Col>
                            </Row>
                            <Row className="rowHeadImg">
                                <Col><img className="headImg" src="/public-static/head3.jpg" alt=""></img></Col>
                                <Col><img className="headImg" src="/public-static/head4.jpg" alt=""></img></Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="colContent-half">
                        <Col className="d-flex justify-content-center align-items-center">
                            <h2>免费看童子，看受生债</h2>
                        </Col>
                    </Row>
                </Container>

            </div >
            <div className='screen5'>
                <Container>
                    <Row xs={1} md={2} className='colContent-half d-flex justify-content-center align-items-center'>
                        <Col xs={10} md={6}>
                            <Row>
                                <Col className="d-flex justify-content-center align-items-center">
                                    <h2>加V jin36945</h2>
                                </Col>
                            </Row>
                            <Row className="connectQRLine">
                                <Col xs={4} className="d-flex justify-content-center align-items-center">
                                    请使用微信扫描二维码
                                </Col>
                                <Col xs={6}>
                                    <img className="connectQR" src="/public-static/connectQR.jpg" alt=""></img>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>

            </div >
        </RoleLayout>
    )
}

export default Home;